import { useMediaQuery } from "@mui/system";
import { Chip, Grid } from "@mui/material";
import { FunctionField, Labeled, NumberField, SelectField, TextField } from "react-admin";
import { settings } from "app";
import { Currency } from "utils/constants";
import { DormitoryRoomTypeStatusChoices } from "utils/choices";
import { SectionTitle } from "features/SectionTitle";

const currencyOptions = { style: "currency", currency: Currency.EUR, minimumFractionDigits: 2 };
const percentOptions = { style: "unit", unit: "percent" };

const booleanChip = value =>
  value ? (
    <Chip
      label="Да"
      color="success"
      size="small"
    />
  ) : (
    <Chip
      label="Не"
      size="small"
    />
  );

const InfoSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <>
      <SectionTitle
        title="Основна информация"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Описание (БГ)">
            <TextField source="descriptionBg" />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Описание (EN)">
            <TextField source="descriptionEn" />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Квадратура">
            <NumberField source="quadrature" />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Брой места">
            <NumberField source="capacity" />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Наем за цялата стая">
            <NumberField
              source="roomRental"
              options={currencyOptions}
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Наем на човек">
            <NumberField
              source="costPerPerson"
              options={currencyOptions}
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Отстъпка за едно дете">
            <NumberField
              source="discountChild"
              options={percentOptions}
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Отстъпка за две и повече деца">
            <NumberField
              source="discountChildren"
              options={percentOptions}
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Тераса">
            <FunctionField render={record => booleanChip(record?.terrace)} />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Подходяща за семейство с деца">
            <FunctionField render={record => booleanChip(record?.suitableForFamily)} />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Подходяща за хора с увреждания">
            <FunctionField render={record => booleanChip(record?.suitableForDisabled)} />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Статус">
            <SelectField
              source="status"
              choices={DormitoryRoomTypeStatusChoices}
            />
          </Labeled>
        </Grid>
      </Grid>
    </>
  );
};

export default InfoSection;
